import { render, staticRenderFns } from "./Cleaners.vue?vue&type=template&id=40cd6998&scoped=true&lang=pug"
import script from "./Cleaners.vue?vue&type=script&lang=js"
export * from "./Cleaners.vue?vue&type=script&lang=js"
import style0 from "./Cleaners.vue?vue&type=style&index=0&id=40cd6998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd6998",
  null
  
)

export default component.exports